import * as actionType from './type';

const INITIAL_STATE = {
   AuditData: [],
   leadAuditData: [],
   auditSearchPayload: null,
   isLoading: false
}

export default function(state = INITIAL_STATE, action) {
    
    switch(action.type) {

        case actionType.REQUEST_AUDIT_LOGS:
        case actionType.REQUEST_LEAD_AUDIT_LOGS: {
            return {
                ...state,
                auditSearchPayload: action.payload || null,
                isLoading: true
            }
        }

        case actionType.RECEIVED_AUDIT_LOGS: {
            return {
                ...state,
                AuditData: action.payload,
                isLoading: false
            }
        }

        case actionType.ERROR_AUDIT_LOGS: {
            return {
                ...state,
                isLoading: false,
                AuditData: []
            }
        }

    
        default: 
            return state;
    }
}
